import type { InstagramAudioTrack } from '../types';

/**
 * Playback URLs are nullable per track — not per audio type — so this is a
 * null check rather than a rule based on `audio_type`.
 */
export function resolvePreviewSrc(
  track: Pick<
    InstagramAudioTrack,
    'download_url' | 'on_platform_audio_preview_link'
  > | null,
): string | null {
  if (!track) return null;

  return track.download_url || track.on_platform_audio_preview_link || null;
}
